import { RemoteSummaryOfTerminationTerms } from 'data/usecases';
import { SummaryOfTerminationTermsUseCaseInterface } from 'domain/usecases';
import { makeApiUrlTceManagement } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeSummaryOfTerminationTerms =
  (): SummaryOfTerminationTermsUseCaseInterface =>
    new RemoteSummaryOfTerminationTerms(
      makeApiUrlTceManagement(),
      makeAxiosHttpClient(),
    );
